import { HasuraQueries } from "@/api/hasura/queries"
import { GetMetersByMpxnMsnQueryVariables } from "@/api/hasura/generated/graphql"
import { useQuery } from "@/api/utils/useQuery"
import { MeterSummaryParser } from "@/models/meterSummary/meterSummary.parser"
import dayjs from "dayjs"

class MeterServiceClass {
  getMetersByMpxnMsn(filters: GetMetersByMpxnMsnQueryVariables) {
    return useQuery({
      ...HasuraQueries.smartMeter.getMetersByMpxnMsn({
        ...filters,
        today: dayjs().toISOString(),
      }),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData) =>
        rawData.meter.map((meter) => MeterSummaryParser.toDomain(meter)),
    })
  }
}

export const MeterService = new MeterServiceClass()
